<template>
  <div class="user-details-photos">
    <template v-if="userDetails.isNotEmptySelfie">
      <div class="user-details-photos__section">
        <h3 class="user-details-photos__subtitle">
          {{ "user-details-photos.key-selfie" | globalize }}
        </h3>

        <div class="user-details-photos__img-wrp">
          <img
            class="app__img-preview"
            :src="userDetails.documents.selfie"
            @click="selectPhotoUrl(userDetails.documents.selfie)"
          >
        </div>
      </div>
    </template>

    <template v-if="userDetails.isNotEmptyDocumentsArray">
      <div class="user-details-photos__section">
        <h3 class="user-details-photos__subtitle">
          {{ 'user-details-photos.key-document-images' | globalize }}
        </h3>

        <a-list
          :grid="{ gutter: 12, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }"
          :data-source="userDetails.documentsArray">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
          >
            <verification-document
              :document="item"
              :on-select-image-url="selectPhotoUrl"
            />
          </a-list-item>
        </a-list>
      </div>
    </template>

    <template v-if="userDetails.isNotEmptyDocImages">
      <div class="user-details-photos__section app-key-value__row">
        <button
          v-ripple
          class="user-details-photos__dropdown-btn"
          type="button"
          @click="isImagesDocsShown = !isImagesDocsShown"
        >
          <i
            class="mdi user-details-photos__dropdown-btn-icon"
            :class="{
              'mdi-chevron-right': !isImagesDocsShown,
              'mdi-chevron-down': isImagesDocsShown
            }"
          />
          <h3 class="user-details-photos__subtitle">
            {{ "user-details-photos.key-document-images" | globalize }}
          </h3>
        </button>
        <template v-if="isImagesDocsShown">
          <div class="user-details-photos__img-wrp">
            <img
              class="app__img-preview"
              v-for="image in userDetails.documents.documentImages"
              :key="image"
              :src="image"
              @click="selectPhotoUrl(image)"
            >
          </div>
        </template>
      </div>
    </template>

    <photo-viewer
      v-if="selectedPhotoUrl"
      :img-url="selectedPhotoUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import AList from 'ant-design-vue/lib/list'
import VerificationDocument from '@/vue/common/verification-document'
import { UserRecord } from '@/js/records/entities/user.record'
import PhotoViewer from '@/vue/common/PhotoViewer'

export default {
  name: 'user-details-photos',
  components: {
    AList,
    'a-list-item': AList.Item,
    PhotoViewer,
    VerificationDocument,
  },
  props: {
    userDetails: {
      type: UserRecord,
      required: true,
    },
  },
  data: () => ({
    selectedPhotoUrl: '',
    isImageViewerShown: false,
    isImagesDocsShown: false,
  }),
  methods: {
    selectPhotoUrl (url) {
      this.selectedPhotoUrl = url
      this.isImageViewerShown = true
    },
  },
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/list/style/index.css';

.user-details-photos__subtitle {
  margin-bottom: 2rem;
}

.user-details-photos__section {
  margin-top: 3rem;
}

.user-details-photos__img-wrp {
  display: flex;
  gap: 1rem;
  max-width: 15rem;
  width: 100%;
}

.user-details-photos__dropdown-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.user-details-photos__dropdown-btn-icon {
  display: block;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  transition: all 0.3s;
}
</style>
